import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue' 
import Home from '../views/Home.vue' 
import MainGallery from '../views/MainGallery.vue' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login
    
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: MainGallery,
    meta: {
      auth: true,
    },
  }
   
  
  // ,{
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes 
})

export default router
